/**
 * Central contact email configuration for the landing page footer.
 * Fill in real addresses here — the footer will automatically turn them
 * into working mailto links. Leave empty for a grey "Coming soon" placeholder.
 */

export interface ContactEmails {
  /** General inquiries */
  contact: string;
  /** Help & technical support */
  support: string;
}

export const CONTACT_EMAILS: ContactEmails = {
  contact: "contact@gtamsculpt.com",
  support: "support@gtamsculpt.com",
};
